import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'ciao-status-badge',
    imports: [NgClass],
    template: `
    <div id="badge" [ngClass]="getStatusClass(status)">
      <span>{{ status }}</span>
    </div>
  `,
    styles: `
  #badge {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 166px;
    height: 43px;
    padding: 0 20px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
  }

  .status-Planned {
    background: #ecf6ef;
    border: 1px solid #397c4d;
    color: #397c4d;
  }
  .status-Open {
    background: #00992e;
    color: #ffffff;
  }
  .status-Late {
    background: #c44d00;
    color: #ffffff;
  }
  .status-Closed {
    background: #ededed;
    border: 1px solid #4e4d4d;
    color: #4e4d4d;
  }
  `
})
export class StatusBadgeComponent {
  @Input() status!: 'Late' | 'Planned' | 'Open' | 'Closed' | 'Uncertain';
  ngOnInit() {}

  getStatusClass(status: string) {
    switch (status) {
      case 'Planned':
        return 'status-Planned';
      case 'Open':
        return 'status-Open';
      case 'Late':
        return 'status-Late';
      case 'Closed':
        return 'status-Closed';
      default:
        return '';
    }
  }
}
